import { render, staticRenderFns } from "./WorksAnywhereCard.vue?vue&type=template&id=0bcf0c1e"
import script from "./WorksAnywhereCard.vue?vue&type=script&lang=js"
export * from "./WorksAnywhereCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsButton: require('/opt/build/repo/components/Elements/Button.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
